'use strict';

class Breadcrumb {

	static BREADCRUMB_EVENT_NAME = 'breadcrumb-change';

	static isBreadcrumbArrayValid = (breadcrumbs) => {
		return breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.every(b => b instanceof Breadcrumb);
	}

	/**
	 * Breadcrumb class for dynamic breadcrumbs passed to breadcrumbController via Loaders.setBreadcrumbs
	 *
	 * @param title {string} 		- the title of the breadcrumb. Should be marked as translatable string with marker function _
	 * @param icon {string} 		- the icon class. will be inserted into <em></em> as class. Example value "fa fa-home"
	 * @param path {string} 		- the content path passed to Loaders.openContent on click.
	 * 								If empty or undefined the breadcrumb will be not clickable.
	 * @param iframeRoute {string}	- iframe route as string. Will be set on click to Loaders.setIFrameRoute.
	 * @param childBreadcrumbs {Breadcrumb[]}	- Provided Breadcrumbs will be set to Loaders.setBreadcrumbs on click
	 */
	constructor(title, icon, path, iframeRoute, childBreadcrumbs) {
		if(title && typeof path === "string") {
			this.title = title;
			this.icon = icon;
			this.path = path;
			this.iframeRoute = iframeRoute ? iframeRoute : '';
			this.childBreadcrumbs = childBreadcrumbs &&
									Array.isArray(childBreadcrumbs) &&
									childBreadcrumbs.every(b => b instanceof Breadcrumb) ?
										childBreadcrumbs :
										[];
		} else {
			throw new Error('unsupported breadcrumb provided. title and path are required.')
		}
	}

	/**
	 * @param bc {Breadcrumb}
	 */
	equals(bc) {
		return this.path === bc.path && this.iframeRoute === bc.iframeRoute && this.title === bc.title
	}

	get isIframe() {
		return !!this.iframeRoute || this.path === 'container.htm';
	}
}

window.Breadcrumb = Breadcrumb;

module.exports = (app) => app.controller('breadcrumbController', /* @ngInject */ function ($scope, iframeConfig) {

	$scope.breadcrumbs = []
	$scope.navigate = navigate;

	init();

	function breadcrumbChangeListener() {
		update();
	}

	function init() {
		update();
		window.addEventListener(Breadcrumb.BREADCRUMB_EVENT_NAME, breadcrumbChangeListener);
	}

	function update() {
		$scope.breadcrumbs = window.getBreadcrumbs();
        if(!$scope.$$phase) {
            $scope.$apply();
        }
	}

	/**
	 * Navigate to breadcrumb
	 * @param breadcrumb {Breadcrumb} - breadcrumb to navigate to
	 */
	function navigate(breadcrumb) {
	    if(breadcrumb?.path.includes('container') && window.location.hash.includes('container')) {
			if(!!breadcrumb?.iframeRoute) {
				navigateWithinIframe(breadcrumb)
			}
        } else if(breadcrumb && breadcrumb.path) {
			if(breadcrumb.iframeRoute) {
				setIFrameRoute(breadcrumb.iframeRoute);
			}
			window.openContent(breadcrumb.path, '', null, breadcrumb.childBreadcrumbs);
		}
	}

    /**
     * Navigate to breadcrumb when we are within an iframe right now and we want to navigate to another iframe route
     * @param breadcrumb {Breadcrumb} - breadcrumb to navigate to
     */
	function navigateWithinIframe(breadcrumb) {
	    // only navigate if this route is not already active
	    if(breadcrumb.iframeRoute !== window.iFrameRoute) {
            window.setIFrameRoute(breadcrumb.iframeRoute);
            iframeConfig.navigateTo(breadcrumb.iframeRoute, window.MAIN_IFRAME_ID);
            const allBreadcrumbs = window.getBreadcrumbs();
            window.setBreadcrumbs(allBreadcrumbs.slice(0, allBreadcrumbs.indexOf(breadcrumb) + 1 ), window.location.hash.replace('#', ''));
        }
    }

	/**
	 * remove event listener on destroy
	 */
	$scope.$on('$destroy', function() {
		window.removeEventListener(Breadcrumb.BREADCRUMB_EVENT_NAME, breadcrumbChangeListener);
	});
});
